// extracted by mini-css-extract-plugin
export var active = "_e5-7";
export var blink = "_e5-8";
export var dropDownSelector = "_e5-4";
export var dropDownWrapper = "_e5-3";
export var fakeCursor = "_e5-6";
export var fontSizeButton = "_e5-9";
export var formQuillEditor = "_e5-0";
export var pressed = "_e5-a";
export var qlBlank = "_e5-1";
export var textFormattingToolbar = "_e5-2";
export var textToolbarOption = "_e5-5";